import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D80000",
      d: "M17.304 18.075c.613-.469 1.024-1.228 1.024-2.306 0-2.967-2.136-3.441-3.588-3.441H7.425v11.737h7.713c1.965 0 3.437-1.175 3.437-3.358 0-1.286-.498-2.14-1.271-2.632m-2.898 2.994h-3.722v-1.486h3.722c.457 0 .747.219.747.742 0 .524-.29.744-.747.744m0-4.25h-3.722v-1.493h3.722c.483 0 .748.22.748.746s-.258.746-.746.746M26.987 20.935v-8.607h-7.042v3.13h3.391v5.477h-3.391v3.13h9.65v-3.13z"
    }, null, -1),
    _createElementVNode("rect", {
      width: "34",
      height: "34",
      x: "1",
      y: "1",
      stroke: "#E5143D",
      "stroke-width": "2",
      rx: "3"
    }, null, -1)
  ])))
}
export default { render: render }